import { useState } from "react";

const CLAMP = { 2: "line-clamp-2", 3: "line-clamp-3" };

// Collapses long text to a few lines with a Show more/less toggle to keep panels light.
export function ClampText({ text, lines = 2, className = "", testId }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  const long = text.length > 160;
  return (
    <div className={className} data-testid={testId}>
      <p className={open || !long ? "" : (CLAMP[lines] || CLAMP[2])}>{text}</p>
      {long && (
        <button onClick={() => setOpen((v) => !v)} className="mt-0.5 text-[11px] font-medium text-[hsl(var(--primary))] hover:underline">
          {open ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}
